import { CellProps } from 'react-table'
import { EspecialidadeVinculosActionsCell } from './EspecialidadeVinculosActionsCell'
import { FormularioEmpresaList } from '../../core/_models'
import { PlainHeader, StackedCell, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

// O endpoint não ordena: cabeçalhos sem ordenação (como já era).
export const vinculosEspecialidadeColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<FormularioEmpresaList>> => [
  {
    Header: () => <PlainHeader>{t('cols.especialidade')}</PlainHeader>,
    id: 'especialidade.nome',
    Cell: ({ row }: CellProps<FormularioEmpresaList>) => (
      <StackedCell primary={row.original.especialidade?.nome} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('empresa.label')}</PlainHeader>,
    id: 'empresa.nome',
    Cell: ({ row }: CellProps<FormularioEmpresaList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.unidade')}</PlainHeader>,
    id: 'unidade.nome',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<FormularioEmpresaList>) => (
      <StackedCell primary={row.original.unidade?.nome} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '100px',
    align: 'end',
    Cell: ({ row }: CellProps<FormularioEmpresaList>) => (
      <EspecialidadeVinculosActionsCell vinculo={row.original} />
    ),
  },
]
